import { getDefaultExportFromCjs } from "./index106.js";
import { __require as requireJsBarcode } from "./index125.js";
var JsBarcodeExports = requireJsBarcode();
const JsBarcode = /* @__PURE__ */ getDefaultExportFromCjs(JsBarcodeExports);
export {
  JsBarcode as default
};
//# sourceMappingURL=index111.js.map
